<template>
    <div id="coach-features">
        <div class="panel-coach-features">
            <h2 class="page-header">Welke eigenschappen vind je prettig bij een coach?</h2>
            <label class="label-header">Kies maximaal 5 eigenschappen. Mijn coach is…</label>
            <div class="two-column checkboxes-container">
                <div class="checkbox-wrapper" v-for="( feature ) in keywords" :key="feature.id">
                    <label>
                        <input type="checkbox" :value="feature.id" :key="feature.id" v-model="answer.features"><span class="tick">{{ feature | alternative_title }}</span>
                    </label>
                </div>
                <div class="checkbox-wrapper">
                  <label>
                    <input type="checkbox" value="" v-model="selectNone"><span class="tick">Weet ik nog niet</span>
                  </label>
                </div>
            </div>
            <div class="alert-container" v-if="!isValid('features')">
                <div class="alert alert-danger" v-if="invalid.features.min">Maak minimaal {{ invalid.features.min }} keuze</div>
                <div class="alert alert-danger" v-if="invalid.features.max">Je mag maximaal {{ invalid.features.max }} opties selecteren</div>
            </div>
            <div class="buttons-container">
                <previous-button />
                <next-button :isValid="isAnswered.features && isValid('features')" />
            </div>
        </div>
    </div>
</template>

<script>
    import NextButton from "../partials/NextButton";
    import PreviousButton from "../partials/PreviousButton";

    export default {
        name: 'Features',
        components: {
            PreviousButton,
            NextButton
        },
        props: {
            isValid: {
                type: Function
            },
            answer: {
                type: Object
            },
            invalid: {
                type: Object
            },
            isAnswered: {
                type: Object
            }
        },
        computed: {
            keywords: function() {
                return this.allFeatures.filter(function (feature) {
                    return feature.type === 'keyword'
                })
            },
            selectNone: {
                get: function () {
                    return this.answer.features.length === 1 && this.answer.features.indexOf("") !== -1;
                },
                set: function (value) {
                    if(value) {
                        this.answer.features = [""];
                    }

                    if (!value && this.answer.features.indexOf("") !== -1) {
                        this.answer.features = [];
                    }
                }
            }
        },
        filters: {
          alternative_title: f => f.title_alternative ? f.title_alternative : f.title,
        },
        data() {
            return {
                allFeatures: allFeatures,
                rules: {
                    features: {
                        min: 1,
                        max: 5
                    }
                }
            }
        },
        created() {
            this.$emit('setRules', this.rules)
        }
    }

</script>
